/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

*/

// Responsive tables init

$(document).ready(function() {
	$('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// FancyBox

$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Login Boxes

$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

// Drawers

var MOBILE_DRAWER_SIZE = 300,
    DESKTOP_DRAWER_SIZE = 390,
    MOBILE_WIDTH_MAX = 768;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).resize(function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    if (!window.slideouts.right) {
        // cart slider is disabled
        return;
    }

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});


function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        if (hidden_menu) {
            hidden_menu.classList.add('slideout-panel-hidden');
        }
        $overlay.fadeIn();
        // document.body.style.overflowY = 'hidden';
        var marginTop = (-document.body.scrollTop) + 'px';
        panel.style.position = 'fixed';
        panel.style.marginTop = marginTop;
    });

    slideout.on('beforeclose', function () {
        $overlay.fadeOut();
        var scrollTop = -parseInt(panel.style.marginTop);
        panel.style.position = '';
        panel.style.marginTop = '';
        document.body.scrollTop = scrollTop;
    });

    slideout.on('close', function() {
        menu.classList.add('slideout-panel-hidden');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        if (hidden_menu) {
            hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
        }
    });

    return slideout;
}

function load_menu_drawer() {

    // Close sliders if they're open
    if (window.slideouts && window.slideouts.left) {
        window.slideouts.left.close();
    }
    if (window.slideouts && window.slideouts.right) {
        window.slideouts.right.close();
    }

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    var body_menu = $('body > #menu');
    var main_body_menu = $('#main-body #menu');
    if (main_body_menu.length > 0) {
        body_menu.remove();
        $('body').append(main_body_menu);
    }

    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').on('click', function() {
        slideoutLeft.toggle();
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    if (!right_menu) {
        // Cart drawer is disabled in the settings
        return;
    }
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
}

$(document).ready(load_menu_drawer);
document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});

// Google Maps JS

// Set map Variables
var MAP_SELECTOR = '.map-wrapper';
var MAP_API_FAILED = false;
var map_objects = [];

function set_map_error(message, container) {
    if (!container) {
        container = $('.map-section__container');
    }
    container.addClass('hide');
    if (Shopify.designMode) {
        $('<div class="map-container-error"></div>').text(message).appendTo(container.parent().find('.map-section__overlay'));
    }
    container.parent().find('.homepage-map--fallback').removeClass('hide');
}

function maps_resize() {
    // Center map when screensize is changed
    map_objects.forEach(function (map) {
        var currCenter = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(currCenter);
    });
}

function map_init(map_element) {
    var config = {
      zoom: 14
    };

    var section = map_element.dataset.id;
    var colors = map_element.dataset.colors;
    var style = [];
    try {
        style = JSON.parse(document.getElementById('homepage-map--theme--' + section).textContent);
    } catch (e) {
        console.error('Unable to parse theme style:', e);
    }
    var container = document.querySelector('#map-container-' + section);
    if (!container) {
        return;
    }
    var $container = $(container);
    if (MAP_API_FAILED) {
        set_map_error('Google Maps authentication error, API key might be invalid', $container);
    }

    var map = new google.maps.Map(container, {
        zoom: config.zoom,
        styles: style,
        disableDefaultUI: true,
        draggable: false,
        clickableIcons: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
    });
    map_objects.push(map);

    var geocoder = new google.maps.Geocoder();

    geocodeAddress(geocoder, map);

    function geocodeAddress(geocoder, resultsMap) {
        var address = $('#map-container-' + section).data('address-setting');
        geocoder.geocode({'address': address}, function(results, status) {
            if (status === 'OK') {
                resultsMap.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: resultsMap,
                    position: results[0].geometry.location
                });
            } else {
                set_map_error('Error looking up that address', $container);
            }
        });
    }
}

// Google Map JS
function load_googlemaps() {
  var apiKey = 'AIzaSyC6RO04tO7XiPGXsDXrSs_5z1qIILOaso8';
  Array.prototype.forEach.call(document.querySelectorAll(MAP_SELECTOR), function (map_element) {
    var section = map_element.dataset.id;
    var elementApiKey = document.querySelector('#apikey-' + section).value;
    if (!elementApiKey) {
        return;
    }
    if (apiKey && elementApiKey && elementApiKey !== apiKey) {
        console.warn('Multiple different Google Maps API keys are not allowed, using only the first one');
        return;
    }
    apiKey = elementApiKey;
  });
  if (!apiKey) {
    console.error('Google Maps API key not provided!');
    set_map_error('Google Maps API key not provided!', null);
    return;
  }

  if (MAP_API_FAILED || !window.google || !window.google.maps || !window.google.maps.Geocoder || !window.google.maps.Map) {
    MAP_API_FAILED = false;
    $.getScript(
        'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=google_maps_loaded'
    );
  } else {
    google_maps_loaded();
  }
}

function google_maps_loaded() {
    Array.prototype.forEach.call(document.querySelectorAll(MAP_SELECTOR), map_init);
    $(window).off('resize', maps_resize).on('resize', maps_resize);
}

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars

function gm_authFailure() {
  MAP_API_FAILED = true;
  console.error('Authentication Failure');

  var $container = $('.map-section__container');

  set_map_error('Google Maps authentication error, API key might be invalid', null);
}


$(document).ready(load_googlemaps);
document.addEventListener('shopify:section:load', function (event) {
        load_googlemaps();
  		init_Map();
});



// ---------------------------------------------------------------------------
// Weekly ordering cutoff helper
// ---------------------------------------------------------------------------
// Returns true if "now" is on or before the ordering cutoff for the delivery
// week that `date` falls in. The cutoff is 11:59:59pm on the Wednesday of the
// week immediately PRECEDING the delivery week (i.e. Monday-of-delivery-week
// minus 5 days). Ordering after that Wednesday pushes the earliest available
// delivery out to the following week's run.
function beforeWeeklyCutoff(date) {
  var d = new Date(date.getTime());
  d.setHours(0, 0, 0, 0);
  var dow = d.getDay();                         // 0 = Sun … 6 = Sat
  var offsetToMonday = (dow === 0 ? -6 : 1 - dow);
  var mondayOfWeek = new Date(d.getTime());
  mondayOfWeek.setDate(d.getDate() + offsetToMonday);
  var cutoff = new Date(mondayOfWeek.getTime());
  cutoff.setDate(mondayOfWeek.getDate() - 5);   // Wednesday of the preceding week
  cutoff.setHours(23, 59, 59, 999);
  return new Date().getTime() <= cutoff.getTime();
}
 
// Areas that use the weekly "Wednesday of the preceding week" ordering cutoff.
var weeklyCutoffAreas = [
  "Canberra",
  "Blue Mountains",
  "Central Coast",
  "Newcastle",
  "Wollongong",
  "Sydney"
];
 
$(document).ready( function() {
  	  $("#delivery-date").val(" ");
      var tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).setHours(0,0,0,0);
      var dateat   = new Date(new Date().getTime() + (48 * 60 * 60 * 1000)).setHours(0,0,0,0);
 
      $("#delivery-date").datepicker( {
        onSelect: function(d,i) {
        	if(d !== i.lastVal) {
          	  $(this).change();
      	    }
        },
        minDate: +2,
        maxDate: '+7M',
        dateFormat: "dd/mm/yy",
        beforeShowDay: function(date) {
          var day = date.getDay();
          var validDay = [(day != 2 && day != 4 && day != 6)];
 
 
          if ($('#delivery-area-sel').val() == "Adelaide") {
            validDay = [true];
          }
 
          if ($('#delivery-area-sel').val() == "Wollongong") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Canberra") {
              var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Blue Mountains") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 4 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Queensland") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Goulburn Bowral") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Central Coast") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Newcastle") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Geelong") {
            var validDay = [(day != 0 && day != 2 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Yarra Valley") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Mount Dandenong") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Sydney") {
            var validDay = [(day != 0 && day != 2 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Illawarra" ||
              $('#delivery-area-sel').val() == "Shoal Haven") {
            var validDay = [(day != 0 && day != 1 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Nowra") {
            var validDay = [(day != 0 && day != 1 && day != 3 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Melbourne") {
            var validDay = [(day != 0 && day != 2 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Surf Coast") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 3 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Gippsland") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 4 && day != 5 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Ballarat Bendigo") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 4 && day != 6)];
          }
 
          if ($('#delivery-area-sel').val() == "Outer Melbourne") {
            var validDay = [(day != 0 && day != 1 && day != 2 && day != 4 && day != 6)];
          }
 
 
           if (validDay) {
                if (date.getTime() >= new Date(2024, 11, 22).getTime() && date.getTime() <= new Date(2025, 0, 8).getTime()) {
                    validDay = [false]; // Disable the date
                }
            }
 
           if (validDay) {
                if (date.getTime() >= new Date(2025,03,18).getTime() && date.getTime() <= new Date(2025,03,29).getTime()) {
                    validDay = [false]; // Disable the date
                }
            }
 
 
          if (validDay) {
            if (date.getTime() == new Date(2024,12,25).getTime() &&
                ($('#delivery-area-sel').val() == "Blue Mountains" ||
                 $('#delivery-area-sel').val() == "Sydney" ||
                 $('#delivery-area-sel').val() == "Central Coast" ||
                 $('#delivery-area-sel').val() == "Goulburn Bowral" ||
                 $('#delivery-area-sel').val() == "Illawarra" ||
                 $('#delivery-area-sel').val() == "Nowra" ||
                 $('#delivery-area-sel').val() == "Shoal Haven" ||
                 $('#delivery-area-sel').val() == "Newcastle")) {
  		      validDay = [false];
			}
 
            if (date.getTime() == new Date(2021,08,17).getTime() &&
                ($('#delivery-area-sel').val() == "Outer Melbourne" ||
                 $('#delivery-area-sel').val() == "Melbourne" ||
                 $('#delivery-area-sel').val() == "Ballarat Bendigo" ||
                 $('#delivery-area-sel').val() == "Geelong" ||
                 $('#delivery-area-sel').val() == "Mount Dandenong" ||
                 $('#delivery-area-sel').val() == "Surf Coast" ||
                 $('#delivery-area-sel').val() == "Yarra Valley" ||
                 $('#delivery-area-sel').val() == "Gippsland")) {
  		      validDay = [false];
			}
 
            if (date.getTime() == new Date(2021,08,24).getTime() &&
                ($('#delivery-area-sel').val() == "Outer Melbourne" ||
                 $('#delivery-area-sel').val() == "Melbourne" ||
                 $('#delivery-area-sel').val() == "Ballarat Bendigo" ||
                 $('#delivery-area-sel').val() == "Geelong" ||
                 $('#delivery-area-sel').val() == "Mount Dandenong" ||
                 $('#delivery-area-sel').val() == "Surf Coast" ||
                 $('#delivery-area-sel').val() == "Yarra Valley" ||
                 $('#delivery-area-sel').val() == "Gippsland")) {
  		      validDay = [false];
			}
 
            if (date.getTime() == new Date(2021,09,04).getTime() &&
                ($('#delivery-area-sel').val() == "Blue Mountains" ||
                 $('#delivery-area-sel').val() == "Sydney" ||
                 $('#delivery-area-sel').val() == "Central Coast" ||
                 $('#delivery-area-sel').val() == "Goulburn Bowral" ||
                 $('#delivery-area-sel').val() == "Illawarra" ||
                 $('#delivery-area-sel').val() == "Nowra" ||
                 $('#delivery-area-sel').val() == "Shoal Haven" ||
                 $('#delivery-area-sel').val() == "Newcastle" ||
                 $('#delivery-area-sel').val() == "Wollongong")) {
  		      validDay = [false];
			}
 
            if (date.getTime() == new Date(2021,09,05).getTime() &&
                ($('#delivery-area-sel').val() == "Blue Mountains" ||
                 $('#delivery-area-sel').val() == "Central Coast" ||
                 $('#delivery-area-sel').val() == "Goulburn Bowral" ||
                 $('#delivery-area-sel').val() == "Illawarra" ||
                 $('#delivery-area-sel').val() == "Nowra" ||
                 $('#delivery-area-sel').val() == "Shoal Haven" ||
                 $('#delivery-area-sel').val() == "Newcastle" ||
                 $('#delivery-area-sel').val() == "Wollongong")) {
  		      validDay = [false];
			}
 
            if (date.getTime() == new Date(2021,08,29).getTime() &&
                ($('#delivery-area-sel').val() == "Blue Mountains" ||
                 $('#delivery-area-sel').val() == "Sydney" ||
                 $('#delivery-area-sel').val() == "Central Coast" ||
                 $('#delivery-area-sel').val() == "Goulburn Bowral" ||
                 $('#delivery-area-sel').val() == "Illawarra" ||
                 $('#delivery-area-sel').val() == "Nowra" ||
                 $('#delivery-area-sel').val() == "Shoal Haven" ||
                 $('#delivery-area-sel').val() == "Newcastle" ||
                 $('#delivery-area-sel').val() == "Wollongong")) {
  		      validDay = [false];
			}
 
 
            if ($('#delivery-area-sel').val() != "Adelaide" &&
                new Date().getDay() == 0 &&
                date.getTime() == tomorrow) {
     	      validDay = [false];
	 	    }
 
            if ($('#delivery-area-sel').val() != "Adelaide" &&
                new Date().getDay() == 6 &&
                date.getTime() == dateat) {
     	      validDay = [false];
	 	    }
 
            if ($('#delivery-area-sel').val() != "Queensland" &&
                new Date().getDay() == 4 &&
                date.getTime() == tomorrow) {
     	      validDay = [false];
	 	    }
 
            if ($('#delivery-area-sel').val() != "Queensland" &&
                new Date().getDay() == 3 &&
                date.getTime() == dateat) {
     	      validDay = [false];
	 	    }
 
            // Weekly ordering cutoff: to receive a delivery in a given week, the
            // order must be placed on or before 11:59pm Wednesday of the PRECEDING
            // week. Ordering Thu–Sun pushes the earliest delivery out a full week.
            if (weeklyCutoffAreas.indexOf($('#delivery-area-sel').val()) !== -1 &&
                !beforeWeeklyCutoff(date)) {
              validDay = [false];
            }
          }
 
          return validDay;
        },
    });
});
 
$(document).ready( function() {
  $('#delivery-date-wrap').click(function(){
    $( "#delivery-date" ).datepicker( "show" );
  });
});
 
 
function checkTime() {
  var startTime = 0; //midnight
  var endTime = 12; // midday
  var date = new Date();
  var curr_time = date.getHours()
 
  if (curr_time >= startTime && curr_time < endTime && $("#store-sel").val() == "Miranda") {
      var minDate = 0;
  } else {
     var minDate = 1;
  }
 
  return minDate;
}
 
$(document).ready( function() {
  	$("#pickup-date").val("");
    $("#pickup-date").datepicker( {
      onSelect: function(d,i) {
      	if(d !== i.lastVal) {
        	$(this).change();
      	}
      },
      minDate: checkTime(),
      maxDate: '+7M',
      dateFormat: "dd/mm/yy",
      beforeShowDay: function(date) {
        var day = date.getDay();
        var today = new Date().setHours(0,0,0,0);
        var tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).setHours(0,0,0,0);
        var validDay = [(date.getTime() != new Date(2018,06,31).getTime())];
 
        if ((date.getDay() == 0 || date.getDay() == 6) &&
            ($("#store-sel").val() == "Fountain Gate" || $("#store-sel").val() == "Highpoint" || $("#store-sel").val() == "Narellan" || $("#store-sel").val() == "Cronulla") &&
            date.getTime() == today) {
          validDay = [false];
        }
 
        if (date.getTime() == today && $("#store-sel").val() == "Highpoint") {
          validDay = [false];
        }
 
        if (date.getTime() == tomorrow && $("#store-sel").val() == "Highpoint") {
          validDay = [false];
        }
 
        if (date.getTime() == today && $("#store-sel").val().startsWith("Metro ")) {
          validDay = [false];
        }
 
        if (date.getTime() == tomorrow && $("#store-sel").val().startsWith("Metro ")) {
          validDay = [false];
        }
 
        if ((day == 0 || day == 6) && $("#store-sel").val() == "Docklands") {
          validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,03,02).getTime() && $("#store-sel").val() != "Cronulla") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,03,04).getTime() && $("#store-sel").val() != "Cronulla") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,00,01).getTime()) {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,03,11).getTime() && $("#store-sel").val() == "Highpoint") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,02,08).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,02,09).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
 
        if ($("#store-sel").val() == "Cronulla") {
          validDay = [false];
        }
 
        if ($("#store-sel").val() == "Miranda") {
          validDay = [false];
        }
 
        if ($("#store-sel").val() == "Parramatta") {
          validDay = [false];
        }
 
        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Top Ryde Kitchen") {
          validDay = [false];
        }
 
        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Bondi") {
          validDay = [false];
        }
 
        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Narellan") {
          validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,08,17).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,08,24).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,08,17).getTime() && $("#store-sel").val() == "Casula") {
            validDay = [false];
        }
 
        if (date.getTime() == new Date(2021,08,26).getTime() && $("#store-sel").val() == "Casula") {
            validDay = [false];
        }
 
        if (validDay) {
                if (date.getTime() >= new Date(2025,03,18).getTime() && date.getTime() <= new Date(2025,03,29).getTime()) {
                    validDay = [false]; // Disable the date
                }
        }
 
        if (date.getTime() == new Date(2021,09,04).getTime() &&
            ($("#store-sel").val() == "Casula" ||
             $("#store-sel").val() == "Bondi" ||
             $("#store-sel").val() == "Narellan" ||
             $("#store-sel").val() == "Top Ryde Kitchen" ||
             $("#store-sel").val() == "Figtree"  ||
             $("#store-sel").val() == "Miranda"  ||
             $("#store-sel").val() == "Parramatta" )) {
            validDay = [false];
        }
 
        return validDay;
      },
  });
});
 

$(document).ready( function() {
  $('#delivery-date-wrap').click(function(){
    $( "#delivery-date" ).datepicker( "show" );
  });
});


function checkTime() {
  var startTime = 0; //midnight
  var endTime = 12; // midday
  var date = new Date();
  var curr_time = date.getHours()
  
  if (curr_time >= startTime && curr_time < endTime && $("#store-sel").val() == "Miranda") {
      var minDate = 0;
  } else {
     var minDate = 1;
  }

  return minDate;
}

$(document).ready( function() {
  	$("#pickup-date").val("");
    $("#pickup-date").datepicker( {
      onSelect: function(d,i) {
      	if(d !== i.lastVal) {
        	$(this).change();
      	}
      },      
      minDate: checkTime(),
      maxDate: '+7M',
      dateFormat: "dd/mm/yy",
      beforeShowDay: function(date) {
        var day = date.getDay();
        var today = new Date().setHours(0,0,0,0);
        var tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).setHours(0,0,0,0);
        var validDay = [(date.getTime() != new Date(2018,06,31).getTime())];
   
        if ((date.getDay() == 0 || date.getDay() == 6) &&
            ($("#store-sel").val() == "Fountain Gate" || $("#store-sel").val() == "Highpoint" || $("#store-sel").val() == "Narellan" || $("#store-sel").val() == "Cronulla") &&
            date.getTime() == today) {
          validDay = [false];
        }
        
        if (date.getTime() == today && $("#store-sel").val() == "Highpoint") {
          validDay = [false];
        }
        
        if (date.getTime() == tomorrow && $("#store-sel").val() == "Highpoint") {
          validDay = [false];
        }
        
        if (date.getTime() == today && $("#store-sel").val().startsWith("Metro ")) {
          validDay = [false];
        }
        
        if (date.getTime() == tomorrow && $("#store-sel").val().startsWith("Metro ")) {
          validDay = [false];
        }

        if ((day == 0 || day == 6) && $("#store-sel").val() == "Docklands") {
          validDay = [false];
        }
       
        if (date.getTime() == new Date(2021,03,02).getTime() && $("#store-sel").val() != "Cronulla") {
            validDay = [false];
        }
       
        if (date.getTime() == new Date(2021,03,04).getTime() && $("#store-sel").val() != "Cronulla") {
            validDay = [false];
        }
       
        if (date.getTime() == new Date(2021,00,01).getTime()) {
            validDay = [false];
        }
       
        if (date.getTime() == new Date(2021,03,11).getTime() && $("#store-sel").val() == "Highpoint") {
            validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,02,08).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,02,09).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
        
        if ($("#store-sel").val() == "Cronulla") {
          validDay = [false];
        }
        
        if ($("#store-sel").val() == "Miranda") {
          validDay = [false];
        }

        if ($("#store-sel").val() == "Parramatta") {
          validDay = [false];
        }
        
        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Top Ryde Kitchen") {
          validDay = [false];
        }

        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Bondi") {
          validDay = [false];
        }

        if ((day == 0 || day == 2 || day == 4 || day == 6) && $("#store-sel").val() == "Narellan") {
          validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,08,17).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,08,24).getTime() && $("#store-sel").val() == "Docklands") {
            validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,08,17).getTime() && $("#store-sel").val() == "Casula") {
            validDay = [false];
        }
        
        if (date.getTime() == new Date(2021,08,26).getTime() && $("#store-sel").val() == "Casula") {
            validDay = [false];
        }

        if (validDay) {
                if (date.getTime() >= new Date(2025,03,18).getTime() && date.getTime() <= new Date(2025,03,29).getTime()) {
                    validDay = [false]; // Disable the date
                }
        }
        
        if (date.getTime() == new Date(2021,09,04).getTime() &&
            ($("#store-sel").val() == "Casula" ||
             $("#store-sel").val() == "Bondi" ||
             $("#store-sel").val() == "Narellan" ||
             $("#store-sel").val() == "Top Ryde Kitchen" ||
             $("#store-sel").val() == "Figtree"  ||
             $("#store-sel").val() == "Miranda"  ||
             $("#store-sel").val() == "Parramatta" )) {
            validDay = [false];
        }
                
        return validDay;
      },
  });
});

$(document).ready( function() {
  $('#pickup-date-wrap').click(function(){
    $( "#pickup-date" ).datepicker( "show" );
  });
});


$(document).ready(function(){
    $("#pickup-date").val("");
    $('#store-sel').val("");
    $('#pickup-time').val("");
    $("#delivery-date").val("");
    $('#delivery-area-sel').val("");

  	$("div#pickup_min").hide();
  	$("div#delivery_min").hide();
  
	$("div#toggler_delivery").hide();
  	$("div#toggler_pickup").hide();
  	$("input#cart_submit").attr("disabled", true);
  	$("input#cart_submit").css("background-color", "#a5d6a7");

    $("button#delivery").click(function(){
        $("button#pickup").removeClass("selected");
        $("button#delivery").addClass("selected");
        $("div#toggler_delivery").fadeIn("2000");
		$("div#toggler_pickup").hide();

      	$("div#delivery_min").fadeIn("2000");
  		$("div#pickup_min").hide();      

        $('#pickup-time').val("");
    	$("#pickup-date").val("");
    	$('#store-sel').val("");

      	var date = $("#delivery-date").val();
     	var date_area = $("#delivery-area-sel").val();
      	if (date != "" && date_area != "") {
      	} else {
        	$("input#cart_submit").attr("disabled", true);
          	$("input#cart_submit").css("background-color", "#a5d6a7");
      	}
    });

    $("button#pickup").click(function(){
        $("button#delivery").removeClass("selected");
        $("button#pickup").addClass("selected");
        $("div#toggler_pickup").fadeIn("2000"); 
      	$("div#toggler_delivery").hide();
        if ($("#pickup-date").val() == "") { 
          $("div#pickup-time-wrap").hide();
        }
      
        var wct_ele2 = document.getElementById("warningCleanseType");

        if (wct_ele2) {
          $("div#warningCleanseType").hide();
        }
        
      	$("div#delivery_min").hide();
  		$("div#pickup_min").fadeIn("2000");        

    	$("#delivery-date").val("");
    	$('#delivery-area-sel').val(""); 

      	var date_pick = $("#pickup-date").val();
        var time_pick = $('#pickup-time').val();
        var store_pick = $('#store-sel').val();   
      	if (date_pick != "" && time_pick != "" && store_pick != "") {
      	} else {
        	$("input#cart_submit").attr("disabled", true);
          	$("input#cart_submit").css("background-color", "#a5d6a7");       
      	}
    });    
});


$(document).ready(function(){
  	$("div#warning").hide();
	if (!$("button#delivery").hasClass("selected") && !$("button#pickup").hasClass("selected")) {
      $("div#warning").show();
    }
});


$(document).ready(function(){
  $("div#warningDelDate").hide();
  $("div#warningDelArea").hide();
  $("div#warningCleanseType").hide();
  $("button#delivery").click(function(){
    $("div#warning").hide();
  	$("div#warningPickDate").hide();
  	$("div#warningPickArea").hide();
  	$("div#warningPickTime").hide();      
    if ($("#delivery-date").val() == "") {
         $("div#warningDelDate").show();
    }
    if ($("#delivery-area-sel").val() == "") {
     $("div#warningDelArea").show();
	}
    var del_date = $("#delivery-date").val();
    var del_area = $("#delivery-area-sel").val();
    $('#delivery-date').change(function() { 
      if ($('#delivery-date').val() == null && $('#delivery-date').val() == '') {
		$("div#warningDelDate").show(); 
      } else { 
        $("div#warningDelDate").hide();
      }
    });
    $('#delivery-area-sel').change(function() { 
      if ($('#delivery-area-sel').val() == null && $('#delivery-area-sel').val() == '') {
		$("div#warningDelArea").show(); 
      } else { 
        $("div#warningDelArea").hide();
        
        var wct_ele = document.getElementById("warningCleanseType");

        if (wct_ele) {
          if ($('#delivery-area-sel').val() == "Canberra" ||
              $('#delivery-area-sel').val() == "Central Coast" ||
              $('#delivery-area-sel').val() == "Goulburn Bowral" ||
              $('#delivery-area-sel').val() == "Blue Mountains" ||
              $('#delivery-area-sel').val() == "Newcastle" ||
              $('#delivery-area-sel').val() == "Surf Coast" ||
              $('#delivery-area-sel').val() == "Gippsland" ||
              $('#delivery-area-sel').val() == "Geelong" ||
              $('#delivery-area-sel').val() == "Yarra Valley" ||
              $('#delivery-area-sel').val() == "Mount Dandenong" ||
              $('#delivery-area-sel').val() == "Ballarat Bendigo" ||
              $('#delivery-area-sel').val() == "Queensland" ||
              $('#delivery-area-sel').val() == "Outer Melbourne") {
            $("div#warningCleanseType").show(); 
          } else {
            $("div#warningCleanseType").hide();
          }
        }
      }
    });    
  });
});


$(document).ready(function(){
  $("div#warningPickDate").hide();
  $("div#warningPickArea").hide();
  $("div#warningPickTime").hide();
  $("button#pickup").click(function(){
    $("div#warning").hide();
  	if ($("#pickup-date").val() == "") {
  		$("div#warningPickDate").show();
	}
  	if ($("#store-sel").val() == "") {
  		$("div#warningPickArea").show();
	}
  	if ($("#pickup-date").val() == "") {
  		$("div#warningPickTime").hide();
	}    
    $("div#warningDelDate").hide();
    $("div#warningDelArea").hide(); 
    var pick_date = $("#pickup-date").val();
    var pick_time = $("#pickup-time").val();
    var pick_area = $("#store-sel").val();
    $('#store-sel').change(function() { 
      if ($('#store-sel').val() == null && $('#store-sel').val() == '') {
		$("div#warningPickArea").show(); 
      } else { 
        $("div#warningPickArea").hide();
      }
    });
    $('#pickup-date').change(function() { 
      if ($('#pickup-date').val() == null && $('#pickup-date').val() == '') {
		$("div#warningPickDate").show(); 
      } else { 
        $("div#warningPickDate").hide();
        $("div#warningPickTime").show();
      }
    });   
    $('#pickup-time').change(function() { 
      if ($('#pickup-time').val() == null && $('#pickup-time').val() == '') {
		$("div#warningPickTime").show(); 
      } else { 
        $("div#warningPickTime").hide();
      }
    });     
  });
});

function setTimes() {
  var date = new Date();
  var date1 = new Date();
  date1.setDate(date.getDate()+1);
  var day = date.getDate();
  var month = (date.getMonth())+1; // 0 indexed
  var year = date.getFullYear();
  var current_hour = date.getHours();
  
  var pattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  var arrayDate = $("#pickup-date").val().match(pattern);
  var puDate = new Date(arrayDate[3], arrayDate[2] - 1, arrayDate[1]);
  var puDay = puDate.getDay();
  
  var today = new Date().setHours(0,0,0,0);
  var tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).setHours(0,0,0,0);

  if (puDate.getTime() == today && $("#store-sel").val() == "Miranda") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").attr("disabled","disabled");
      $("#pickup-time-12pm").css("font-weight", "normal");
      $("#pickup-time-1pm").attr("disabled","disabled");
      $("#pickup-time-1pm").css("font-weight", "normal");
      $("#pickup-time-2pm").attr("disabled","disabled");
      $("#pickup-time-2pm").css("font-weight", "normal");
      $("#pickup-time-3pm").attr("disabled","disabled");
      $("#pickup-time-3pm").css("font-weight", "normal");
      $("#pickup-time-4pm").attr("disabled","disabled");
      $("#pickup-time-4pm").css("font-weight", "normal");
      $("div#pickup-time-wrap").fadeIn("2000");
  } else if (puDate.getTime() == today) {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").attr("disabled","disabled");
      $("#pickup-time-12pm").css("font-weight", "normal");
      $("#pickup-time-1pm").attr("disabled","disabled");
      $("#pickup-time-1pm").css("font-weight", "normal");
      $("#pickup-time-2pm").attr("disabled","disabled");
      $("#pickup-time-2pm").css("font-weight", "normal");
      $("#pickup-time-3pm").attr("disabled","disabled");
      $("#pickup-time-3pm").css("font-weight", "normal");
      $("#pickup-time-4pm").attr("disabled","disabled");
      $("#pickup-time-4pm").css("font-weight", "normal");
      $("div#pickup-time-wrap").fadeIn("2000");
  } else if (puDate.getTime() == tomorrow) {
    if ($("#store-sel").val() == "Casula") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").attr("disabled","disabled");
      $("#pickup-time-12pm").css("font-weight", "normal");
      $("#pickup-time-1pm").removeAttr("disabled");
      $("#pickup-time-1pm").css("font-weight", "bold");
      $("#pickup-time-2pm").removeAttr("disabled");
      $("#pickup-time-2pm").css("font-weight", "bold");
      $("#pickup-time-3pm").removeAttr("disabled");
      $("#pickup-time-3pm").css("font-weight", "bold");
      $("#pickup-time-4pm").removeAttr("disabled");
      $("#pickup-time-4pm").css("font-weight", "bold");
      $("div#pickup-time-wrap").fadeIn("2000");
    } else if ($("#store-sel").val() == "Castle Towers") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").attr("disabled","disabled");
      $("#pickup-time-12pm").css("font-weight", "normal");
      $("#pickup-time-1pm").removeAttr("disabled");
      $("#pickup-time-1pm").css("font-weight", "bold");
      $("#pickup-time-2pm").removeAttr("disabled");
      $("#pickup-time-2pm").css("font-weight", "bold");
      $("#pickup-time-3pm").removeAttr("disabled");
      $("#pickup-time-3pm").css("font-weight", "bold");
      $("#pickup-time-4pm").removeAttr("disabled");
      $("#pickup-time-4pm").css("font-weight", "bold");
      $("div#pickup-time-wrap").fadeIn("2000");
    } else if (current_hour >= 15 && current_hour <=23 && $("#store-sel").val() != "Highpoint") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").removeAttr("disabled");
      $("#pickup-time-12pm").css("font-weight", "bold");
      $("#pickup-time-1pm").removeAttr("disabled");
      $("#pickup-time-1pm").css("font-weight", "bold");
      $("#pickup-time-2pm").removeAttr("disabled");
      $("#pickup-time-2pm").css("font-weight", "bold");
      $("#pickup-time-3pm").removeAttr("disabled");
      $("#pickup-time-3pm").css("font-weight", "bold");
      $("#pickup-time-4pm").removeAttr("disabled");
      $("#pickup-time-4pm").css("font-weight", "bold");
      $("div#pickup-time-wrap").fadeIn("2000"); 
    } else if (current_hour >= 12 && current_hour <=23 && $("#store-sel").val() == "Highpoint") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
      $("#pickup-time-12pm").attr("disabled","disabled");
      $("#pickup-time-12pm").css("font-weight", "normal");
      $("#pickup-time-1pm").attr("disabled","disabled");
      $("#pickup-time-1pm").css("font-weight", "normal");
      $("#pickup-time-2pm").attr("disabled","disabled");
      $("#pickup-time-2pm").css("font-weight", "normal");
      $("#pickup-time-3pm").removeAttr("disabled");
      $("#pickup-time-3pm").css("font-weight", "bold");
      $("#pickup-time-4pm").removeAttr("disabled");
      $("#pickup-time-4pm").css("font-weight", "bold");
      $("div#pickup-time-wrap").fadeIn("2000"); 
    } else {
      $("#pickup-time-9am").removeAttr("disabled");
      $("#pickup-time-9am").css("font-weight", "bold");
      $("#pickup-time-10am").removeAttr("disabled");
      $("#pickup-time-10am").css("font-weight", "bold");
      $("#pickup-time-11am").removeAttr("disabled");
      $("#pickup-time-11am").css("font-weight", "bold");
      $("#pickup-time-12pm").removeAttr("disabled");
      $("#pickup-time-12pm").css("font-weight", "bold");
      $("#pickup-time-1pm").removeAttr("disabled");
      $("#pickup-time-1pm").css("font-weight", "bold");
      $("#pickup-time-2pm").removeAttr("disabled");
      $("#pickup-time-2pm").css("font-weight", "bold");
      $("#pickup-time-3pm").removeAttr("disabled");
      $("#pickup-time-3pm").css("font-weight", "bold");
      $("#pickup-time-4pm").removeAttr("disabled");
      $("#pickup-time-4pm").css("font-weight", "bold");
      $("div#pickup-time-wrap").fadeIn("2000"); 
    }
  } else {
    $("#pickup-time-9am").removeAttr("disabled");
    $("#pickup-time-9am").css("font-weight", "bold");
    $("#pickup-time-10am").removeAttr("disabled");
    $("#pickup-time-10am").css("font-weight", "bold");
    $("#pickup-time-11am").removeAttr("disabled");
    $("#pickup-time-11am").css("font-weight", "bold");
    $("#pickup-time-12pm").removeAttr("disabled");
    $("#pickup-time-12pm").css("font-weight", "bold");
    $("#pickup-time-1pm").removeAttr("disabled");
    $("#pickup-time-1pm").css("font-weight", "bold");
    $("#pickup-time-2pm").removeAttr("disabled");
    $("#pickup-time-2pm").css("font-weight", "bold");
    $("#pickup-time-3pm").removeAttr("disabled");
    $("#pickup-time-3pm").css("font-weight", "bold");
    $("#pickup-time-4pm").removeAttr("disabled");
    $("#pickup-time-4pm").css("font-weight", "bold");
  	$("div#pickup-time-wrap").fadeIn("2000");   
  }
  
  if ($("#store-sel").val() == "Docklands") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-2pm").attr("disabled","disabled");
    $("#pickup-time-2pm").css("font-weight", "normal");
    $("#pickup-time-3pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Cronulla") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Narellan") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-3pm").attr("disabled","disabled");
    $("#pickup-time-3pm").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Figtree") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Highpoint") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-10am").attr("disabled","disabled");
    $("#pickup-time-10am").css("font-weight", "normal");
    $("#pickup-time-11am").attr("disabled","disabled");
    $("#pickup-time-11am").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Highpoint" && puDay == 0) {
    $("#pickup-time-10am").attr("disabled","disabled");
    $("#pickup-time-10am").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Miranda") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-3pm").attr("disabled","disabled");
    $("#pickup-time-3pm").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Fountain Gate") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Bondi") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-3pm").attr("disabled","disabled");
    $("#pickup-time-3pm").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Top Ryde Kitchen") {
    $("#pickup-time-9am").attr("disabled","disabled");
    $("#pickup-time-9am").css("font-weight", "normal");
    $("#pickup-time-3pm").attr("disabled","disabled");
    $("#pickup-time-3pm").css("font-weight", "normal");
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
  
  if (puDate.getTime() == new Date(2021,03,03).getTime() && $("#store-sel").val() != "Bondi" && $("#store-sel").val() != "Cronulla") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
  }
  
  if (puDate.getTime() == new Date(2021,03,05).getTime() && $("#store-sel").val() != "Bondi" && $("#store-sel").val() != "Cronulla") {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
  }
  
  if (puDate.getTime() == new Date(2021,00,02).getTime()) {
      $("#pickup-time-9am").attr("disabled","disabled");
      $("#pickup-time-9am").css("font-weight", "normal");
      $("#pickup-time-10am").attr("disabled","disabled");
      $("#pickup-time-10am").css("font-weight", "normal");
      $("#pickup-time-11am").attr("disabled","disabled");
      $("#pickup-time-11am").css("font-weight", "normal");
  }
  
  if ($("#store-sel").val() == "Casula" && puDay == 0) {
    $("#pickup-time-4pm").attr("disabled","disabled");
    $("#pickup-time-4pm").css("font-weight", "normal");
  }
}

$(document).ready(function() {
  	$("div#pickup-time-wrap").hide();
	$("input#cart_submit").attr("disabled", true);
  	$("input#cart_submit").css("background-color", "#a5d6a7");

  	$('#delivery-date').change(function() { 
        if ($('#delivery-date').val() !== null && $('#delivery-date').val() !== '' &&
            $('#delivery-area-sel').val() !== null && $('#delivery-area-sel').val() !== '') {
    	  $("input#cart_submit").attr("disabled", false);
      	  $("input#cart_submit").css("background-color", "#4caf50");
        }
        var wct_ele3 = document.getElementById("warningCleanseType");

        if (wct_ele3 &&
            ($('#delivery-area-sel').val() == "Canberra" ||
             $('#delivery-area-sel').val() == "Central Coast" ||
             $('#delivery-area-sel').val() == "Goulburn Bowral" ||
             $('#delivery-area-sel').val() == "Newcastle" ||
             $('#delivery-area-sel').val() == "Blue Mountains" ||
             $('#delivery-area-sel').val() == "Surf Coast" ||
             $('#delivery-area-sel').val() == "Gippsland" ||
             $('#delivery-area-sel').val() == "Geelong" ||
             $('#delivery-area-sel').val() == "Yarra Valley" ||
             $('#delivery-area-sel').val() == "Mount Dandenong" ||
             $('#delivery-area-sel').val() == "Ballarat Bendigo" ||
             $('#delivery-area-sel').val() == "Outer Melbourne")) {
	      $("input#cart_submit").attr("disabled", true);
  	      $("input#cart_submit").css("background-color", "#a5d6a7");
        }
  	});
  	$('#delivery-area-sel').change(function() { 
        $("#delivery-date").val("");
	    $("input#cart_submit").attr("disabled", true);
  	    $("input#cart_submit").css("background-color", "#a5d6a7");
      
        if ($('#delivery-date').val() !== null && $('#delivery-date').val() !== '' &&
            $('#delivery-area-sel').val() !== null && $('#delivery-area-sel').val() !== '') {
    	  $("input#cart_submit").attr("disabled", false);
      	  $("input#cart_submit").css("background-color", "#4caf50");
        }
        var wct_ele4 = document.getElementById("warningCleanseType");

        if (wct_ele4 &&
            ($('#delivery-area-sel').val() == "Canberra" ||
             $('#delivery-area-sel').val() == "Central Coast" ||
             $('#delivery-area-sel').val() == "Goulburn Bowral" ||
             $('#delivery-area-sel').val() == "Newcastle" ||
             $('#delivery-area-sel').val() == "Surf Coast" ||
             $('#delivery-area-sel').val() == "Blue Mountains" ||
             $('#delivery-area-sel').val() == "Gippsland" ||
             $('#delivery-area-sel').val() == "Geelong" ||
             $('#delivery-area-sel').val() == "Yarra Valley" ||
             $('#delivery-area-sel').val() == "Mount Dandenong" ||
             $('#delivery-area-sel').val() == "Ballarat Bendigo" ||
             $('#delivery-area-sel').val() == "Outer Melbourne")) {
	      $("input#cart_submit").attr("disabled", true);
  	      $("input#cart_submit").css("background-color", "#a5d6a7");
        }
  	});

  	$('#pickup-date').change(function() {
        $("div#pickup-time").hide();
        $('#pickup-time').val("");
        $("input#cart_submit").attr("disabled", true);
        $("input#cart_submit").css("background-color", "#a5d6a7");

      	setTimes();
        if ($('#pickup-date').val() !== null && $('#pickup-date').val() !== '' &&
            $('#store-sel').val() !== null && $('#store-sel').val() !== '' &&
            $('#pickup-time').val() !== null && $('#pickup-time').val() !== '') {

    	  $("input#cart_submit").attr("disabled", false);
		  $("input#cart_submit").css("background-color", "#4caf50");
        }
  	});

  	$('#pickup-time').change(function() {
        if ($('#pickup-date').val() !== null && $('#pickup-date').val() !== '' &&
            $('#store-sel').val() !== null && $('#store-sel').val() !== '' &&
            $('#pickup-time').val() !== null && $('#pickup-time').val() !== '') {

    	  $("input#cart_submit").attr("disabled", false);
		  $("input#cart_submit").css("background-color", "#4caf50");
        }
  	});
  	$('#store-sel').change(function() {

        $('#pickup-time').val("");
    	$("#pickup-date").val("");
	    $("input#cart_submit").attr("disabled", true);
        $("input#cart_submit").css("background-color", "#a5d6a7");
        $("div#warningPickDate").show();
        $("div#warningPickTime").hide();
        $("div#pickup-time").hide();
        $("div#pickup-time-wrap").hide();
  	});
});

$(document).ready(function() {
  $('#pickup-date').change(function() {
    var date = $("#pickup-date").datepicker('getDate');
    var dayOfWeek = date.getUTCDay();
    if (dayOfWeek == 6) { 
        $("#pickup-time-9am").attr("disabled","disabled");
     	$("#pickup-time-9am").css("font-weight", "normal");
    }
  });
});

$(document).ready(function() {
  	$(".quantity-controls").on('click','button', function () {
      $("#update_quantities").click();
	});
  	$(".quantity-controls").on('change','input', function () {
      $("#update_quantities").click();
	});
});

$(document).ready( function() {
  var jlAccordianAcc = document.getElementsByClassName("jl-accordion");
  var jlAccordianI;

  for (jlAccordianI = 0; jlAccordianI < jlAccordianAcc.length; jlAccordianI++) {
    jlAccordianAcc[jlAccordianI].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.padding = "0 18px";
        panel.style.maxHeight = null;
      } else {
        panel.style.padding = "10px 18px";
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
});

$(document).ready( function() {
  $(".sliding-link").click(function(e) {
      e.preventDefault();
      var aid = $(this).attr("href");
      $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
  });
});

$(document).ready( function() {
  $("#career_submit").hide();
  $("#upload").change(function() {
    var allowed = "pdf";
    var fileName = $("#upload").val();
    var extension = fileName.split('.').pop().toLowerCase();
    if (!(allowed===extension))
    {
    	alert("Invalid file type. Please upload a PDF file.");
    } else {
      $("#career_submit").fadeIn("2000"); 
    }
  });
});


